export function groupFixturesByDate(fixtures = []) {
  if (!Array.isArray(fixtures)) return {}

  const grouped = fixtures.reduce((acc, fixture) => {
    // Parse as UTC, then convert to local date and time
    const utcDate = new Date(fixture.starting_at.replace(' ', 'T') + 'Z')
    const localYear = utcDate.getFullYear()
    const localMonth = String(utcDate.getMonth() + 1).padStart(2, '0')
    const localDay = String(utcDate.getDate()).padStart(2, '0')
    const localHours = String(utcDate.getHours()).padStart(2, '0')
    const localMinutes = String(utcDate.getMinutes()).padStart(2, '0')
    const localSeconds = String(utcDate.getSeconds()).padStart(2, '0')
    const localDate = `${localYear}-${localMonth}-${localDay}`

    // Replace starting_at with local date-time string
    const localDateTime = `${localYear}-${localMonth}-${localDay} ${localHours}:${localMinutes}:${localSeconds}`

    const localizedFixture = {
      ...fixture,
      starting_at: localDateTime,
    }

    if (!acc[localDate]) {
      acc[localDate] = []
    }
    acc[localDate].push(localizedFixture)

    return acc
  }, {})

  Object.keys(grouped).forEach((date) => {
    grouped[date].sort(
      (a, b) =>
        new Date(a.starting_at.replace(' ', 'T')) -
        new Date(b.starting_at.replace(' ', 'T'))
    )
  })

  // Create a new object with sorted date keys
  const sortedGrouped = Object.keys(grouped)
    .sort()
    .reduce((acc, date) => {
      acc[date] = grouped[date]
      return acc
    }, {})

  return sortedGrouped
}
